import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';
import { useAuth } from '../contexts/AuthContext';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const homePath = isAuthenticated ? '/app' : '/';

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <SEO title="404 - Page Not Found" noindex={true} />
      <div className="text-center max-w-md">
        <h1 className="text-7xl font-bold text-amber-400 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          {t('errors.page_not_found', 'Page not found')}
        </h2>
        <p className="text-muted-foreground mb-8">
          {t('errors.page_not_found_desc', "The page you're looking for doesn't exist or has been moved.")}
        </p>
        <div className="flex gap-3 justify-center">
          <Button asChild>
            <Link to={homePath}>
              <Home className="w-4 h-4 mr-2" />
              {t('errors.go_home', 'Go Home')}
            </Link>
          </Button>
          {!isAuthenticated && (
            <Button variant="outline" asChild>
              <Link to="/app">
                {t('errors.go_to_app', 'Open App')}
              </Link>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
